module.exports = __webpack_public_path__ + "static/img/ikonapowerpoint.d4fe2020.png";